import React from 'react';
import { CircularIndeterminate, CircularIndeterminate2 } from './../../routes/components/routes/progressbar/circular/indeterminate/CircularIndeterminate';
import { createNotification, getFormattedDate, getImageSourceFromType, getUnitFromType } from 'util/util';

import { Link } from 'react-router-dom';
import { updateThresholdsData, getNotifications, closeNotification } from 'util/aws-manager';
import { updateUserAttributes } from 'util/user-manager';
import * as CONST from 'util/app-constants';
import { connect } from 'react-redux';
import { NotificationContainer } from 'react-notifications';
import { highlightNavigatedMenu } from 'util/highlightSidebarOption';


class App extends React.Component {
    activeNotifications = [];
    closedNotifications = [];
    oldPath;
    pageNumberClosed = 1;
    pageNumberActive = 1;

    constructor(props) {
        super(props);

        this.state = {
            isSMSChecked: this.props.isSMSNotificationChecked,
            setToAllDevices: false,
            activeNotificationsJSX: null,
            closedNotificationsJSX: null,
            showMoreActiveNotifications: null,
            showMoreClosedNotifications: null,
            thresholdSpatialValue: this.props.thresholds.thresholdSpatialValue,
            thresholdPowerValue: this.props.thresholds.thresholdPowerValue,
            thresholdGasValue: this.props.thresholds.thresholdGasValue,
            thresholdWaterTime: this.props.thresholds.thresholdWaterTime,
            thresholdGasTime: this.props.thresholds.thresholdGasTime,
            thresholdPowerVolt: this.props.thresholds.thresholdPowerVolt,
            thresholdIntrusionValue: this.props.thresholds.thresholdIntrusionValue,
            showUpdateButton: true,
            showRefreshButtonActive: true,
            showRefressButtonClose: true,
            loadStatusActiveTable: (<div className="forCenter">
                <CircularIndeterminate />
            </div>),
            loadStatusCloseTable: (<div className="forCenter">
                <CircularIndeterminate />
            </div>),
            loadStatusUpdateThreshold: '',
            refreshActiveTable: '',
            refreshCloseTable: '',
            activeNotifications: [],
            closedNotifications: [],
            activeResults: '',
            closedResults: '',

            // Setting initial values for partial loader state for active notifications data
            // and closed notifications data
            partialLoaderStateActiveNotificationsData: true,
            partialLoaderStateClosedNotificationsData: true,

            hasPageRenderedOnce: false
        };

        this.updateAttribute.bind(this);
        this.onManualClearClick.bind(this);
        this.onActiveNotificationsShowMoreClick.bind(this);
        this.onClosedNotificationsShowMoreClick.bind(this);

        this.spatialDepthThresholdChange.bind(this);
        this.waterTimeThresholdChange.bind(this);
        this.gasLeakageThresholdChange.bind(this);
        this.gasTimeThresholdChange.bind(this);
        this.powerLeakageThresholdChange.bind(this);
        this.powerVoltThresholdChange.bind(this);
        this.intrusionThresholdChange.bind(this);
    }

    toggleSMSCheckbox = () => {
        this.setState({
            isSMSChecked: !this.state.isSMSChecked
        }, () => {
            this.updateAttribute([{
                Name: 'custom:smsNotification',
                Value: this.state.isSMSChecked.toString(),
            }]);
        })
    };

    componentDidMount() {
        this.requestActiveNotificationsWrapper(this.pageNumberActive);
        this.requestClosedNotificationsWrapper(this.pageNumberClosed);
        const { history } = this.props;
        this.setSMSCheckboxValueInBoolean();
        this.oldPath = `#${history.location.pathname}`;
    }

    setSMSCheckboxValueInBoolean = () => {
        if (this.state.isSMSChecked === 'true') {
            this.setState({
                isSMSChecked: true
            })
        }
        else if (this.state.isSMSChecked === 'false') {
            this.setState({
                isSMSChecked: false
            })
        }
    };

    updateAttribute = (attibuteList) => {
        updateUserAttributes(attibuteList)
            .then(() => {
                const data = this.props.userAttributes;
                if (attibuteList[0].Name === 'custom:smsNotification') {
                    createNotification('Update successful.', 'Success', 'Success');
                    data['custom:smsNotification'] = this.state.isSMSChecked;
                    this.props.smsNotification(this.state.isSMSChecked);
                    // this.props.profileDetailsUpdate(data);
                }
            }, (error) => {
                createNotification(error.message, 'Error', 'Error');
            });
    };

    componentWillUnmount() {
        this.props.removeActiveNotificationTimestampFromProps(this.props.deviceId);
    }

    requestActiveNotificationsWrapper = (pageNumberActive, deviceId = this.props.deviceId) => {

        const self = this;

        getNotifications(pageNumberActive, deviceId)
            .then((data) => {
                this.populateActiveNotificationsJSX(data.open);
                self.setState({
                    partialLoaderStateActiveNotificationsData: false
                });
                // this.populateClosedNotificationsJSX(data);
            }, () => {
                self.setState({
                    partialLoaderStateActiveNotificationsData: false
                });
            });
    };

    requestClosedNotificationsWrapper = (pageNumberClosed, deviceId = this.props.deviceId) => {

        const self = this;

        getNotifications(pageNumberClosed, deviceId)
            .then((data) => {

                console.log("Closed notifications", data.closed);

                this.populateClosedNotificationsJSX(data.closed);
                self.setState({
                    partialLoaderStateClosedNotificationsData: false
                });
                // this.populateClosedNotificationsJSX(data);
            }, () => {

                self.setState({
                    partialLoaderStateClosedNotificationsData: false
                });

            });
    };

    populateActiveNotificationsJSX = (data) => {
        let buttonValue = '';
        if (data) {
            // if (data.Items.length != data.Count) {
            //     this.pageNumberActive = this.pageNumberActive + 1;
            //     buttonValue = (<button
            //         className="btn-showMore"
            //         onClick={() => {
            //             this.onActiveNotificationsShowMoreClick(this.pageNumberActive);
            //         }}
            //     >Show More...</button>);
            // }

            data.forEach((item) => {
                this.activeNotifications.push(item);
            });
        }
        if (!this.state.activeNotifications.length) {
            this.setState({
                activeResults: 'No results to display',
            });
        }
        const activeNotificationsJSX = this.activeNotifications.map((el) => {
            return this.returnJSXRow(el);
        });

        this.setState({
            loadStatusActiveTable: '',
            showRefreshButtonActive: true,
            refreshActiveTable: '',
            activeNotificationsJSX,
            showMoreActiveNotifications: buttonValue,
            activeNotifications: this.activeNotifications,
        });
    };

    onActiveNotificationsShowMoreClick = (pageNumberActive) => {
        this.setState({
            loadStatusActiveTable: (<div className="forCenter">
                <CircularIndeterminate />
            </div>),
            showMoreActiveNotifications: '',
        });

        if (pageNumberActive) {
            this.requestActiveNotificationsWrapper(pageNumberActive);
        }
    };

    onClosedNotificationsShowMoreClick = (pageNumberClosed) => {
        this.setState({
            loadStatusCloseTable: (<div className="forCenter">
                <CircularIndeterminate />
            </div>),
            showMoreClosedNotifications: '',
        });

        if (pageNumberClosed) {
            this.requestClosedNotificationsWrapper(pageNumberClosed);
        }
    };

    populateClosedNotificationsJSX = (data) => {
        let buttonValue = null;
        if (data) {
            // if (data.Items.length != data.Count) {
            //     this.pageNumberClosed = this.pageNumberClosed + 1;
            //     buttonValue = (<button
            //         className="btn-showMore"
            //         onClick={() => {
            //             this.onClosedNotificationsShowMoreClick(this.pageNumberClosed);
            //         }}
            //     >Show More...</button>);
            // }

            data.forEach((item) => {
                this.closedNotifications.push(item);
            });
        }
        if (!this.state.closedNotifications.length) {
            this.setState({
                closedResults: 'No results to display',
            });
        }
        const closedNotificationsJSX = this.closedNotifications.map((el) => {
            return this.returnJSXRowClosed(el);
        });

        this.setState({
            loadStatusCloseTable: '',
            showRefressButtonClose: true,
            refreshCloseTable: '',
            closedNotificationsJSX,
            showMoreClosedNotifications: buttonValue,
            closedNotifications: this.closedNotifications,
        });
    };

    returnJSXRowClosed = (el) => {
        return (<tr key={el.time}>
            <td>
                <div className="row">
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="col-4">
                            <img src={getImageSourceFromType(el.event)} />
                        </div>
                        <div className="col-8">
                            <span>{el.event}</span>
                        </div>
                    </div>
                </div>

            </td>
            <td>{getFormattedDate(el.time, false)}</td>
            <td>
                <p>
                    <Link to="/app/components/heartbeat" onClick={() => {
                        highlightNavigatedMenu('heartbeat', this.oldPath);
                    }}>
                        <span>Click to view pit.</span>
                    </Link>
                </p>
            </td>
            <td>{el.val}{getUnitFromType(el.event)}</td>
            <td>
                <u>Cleared Manually</u>
            </td>
            {/* onClick={this.onManualClearClick.bind(this, el.id)} {el.action} */}
        </tr>);
    };

    handleProcessLoadedActiveTable() {
        this.setState({ loadStatusActiveTable: '' });
    }

    handleProcessLoadedClosedTable() {
        this.setState({ loadStatusCloseTable: '' });
    }

    returnJSXRow = (el) => {

        return (<tr key={el.time} className={el.time === this.props.notificationPageTimestampOfElementToHighlight ? "selectedNotification" : ""}>
            <td>
                <div className="row">
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="col-4">
                            <img src={getImageSourceFromType(el.event)} />
                        </div>
                        <div className="col-8">
                            <span>{el.event}</span>
                        </div>
                    </div>
                </div>

            </td>
            <td>{getFormattedDate(el.time, false)}</td>
            <td>
                <p>
                    <Link to="/app/components/heartbeat">
                        <span>Click to view pit.</span>
                    </Link>
                </p>
            </td>
            <td>{el.val}{getUnitFromType(el.event)}</td>
            <td className="manual-clear-hover"
                onClick={() => {
                    this.onManualClearClick(this.props.deviceId, el.time);
                }}
            >
                <u>Manual Clear</u>
            </td>
        </tr>);
    };

    onManualClearClick = (deviceId, notificationTimestamp) => {
        closeNotification(notificationTimestamp, deviceId)
            .then(() => {
                createNotification('Manual clear successful', 'Success', 'Success');
                this.props.manualClearClicked(deviceId, notificationTimestamp);
                this.pageNumberActive = 1;
                this.pageNumberClosed = 1;
                this.activeNotifications = [];
                this.closedNotifications = [];

                this.requestActiveNotificationsWrapper(this.pageNumberActive);
                this.requestClosedNotificationsWrapper(this.pageNumberClosed);
            }).catch(() => {
                createNotification('Manual clear error. Please try again', 'Error', 'Error');
            });
    };

    spatialDepthThresholdChange = (evt) => {
        if (!isNaN(evt.target.value)) {
            this.setState({ thresholdSpatialValue: evt.target.value });
        }
    };
    waterTimeThresholdChange = (evt) => {
        if (!isNaN(evt.target.value)) {
            this.setState({ thresholdWaterTime: evt.target.value });
        }
    };
    gasLeakageThresholdChange = (evt) => {
        if (!isNaN(evt.target.value)) {
            this.setState({ thresholdGasValue: evt.target.value });
        }
    };
    gasTimeThresholdChange = (evt) => {
        if (!isNaN(evt.target.value)) {
            this.setState({ thresholdGasTime: evt.target.value });
        }
    };
    powerLeakageThresholdChange = (evt) => {
        if (!isNaN(evt.target.value)) {
            this.setState({ thresholdPowerValue: evt.target.value });
        }
    };
    powerVoltThresholdChange = (evt) => {
        if (!isNaN(evt.target.value)) {
            this.setState({ thresholdPowerVolt: evt.target.value });
        }
    };
    intrusionThresholdChange = (evt) => {
        if (!isNaN(evt.target.value)) {
            this.setState({ thresholdIntrusionValue: evt.target.value });
        }
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.deviceId !== this.props.deviceId || nextProps.notificationPageTimestampOfElementToHighlight !== this.props.notificationPageTimestampOfElementToHighlight) {
            this.activeNotifications = [];
            this.closedNotifications = [];
            this.pageNumberClosed = 1;
            this.pageNumberActive = 1;
            this.requestActiveNotificationsWrapper(this.pageNumberActive, nextProps.deviceId);
            this.requestClosedNotificationsWrapper(this.pageNumberClosed, nextProps.deviceId);
        }

        if (nextProps.isSMSChecked !== this.state.isSMSChecked) {
            this.setState({
                isSMSChecked: nextProps.isSMSNotificationChecked
            })
        }

        if (!Object.is(nextProps, this.props)) {
            this.setState({
                thresholdSpatialValue: nextProps.thresholds.thresholdSpatialValue,
                thresholdPowerValue: nextProps.thresholds.thresholdPowerValue,
                thresholdGasValue: nextProps.thresholds.thresholdGasValue,
                thresholdWaterTime: nextProps.thresholds.thresholdWaterTime,
                thresholdGasTime: nextProps.thresholds.thresholdGasTime,
                thresholdPowerVolt: nextProps.thresholds.thresholdPowerVolt,
                thresholdIntrusionValue: nextProps.thresholds.thresholdIntrusionValue,
                activeNotifications: this.activeNotifications,
                closedNotifications: this.closedNotifications,
            });
        }
    }

    onUpdateClick = () => {
        this.setState({
            showUpdateButton: false,
            loadStatusUpdateThreshold: (<div className="forCenter">
                <CircularIndeterminate2 />
            </div>),
        });

        const updatedThresholds = {
            thresholdGasTime: this.state.thresholdGasTime,
            thresholdGasValue: this.state.thresholdGasValue,
            thresholdIntrusionValue: this.state.thresholdIntrusionValue,
            thresholdPowerValue: this.state.thresholdPowerValue,
            thresholdPowerVolt: this.state.thresholdPowerVolt,
            thresholdSpatialValue: this.state.thresholdSpatialValue,
            thresholdWaterTime: this.state.thresholdWaterTime,
        };

        updateThresholdsData(this.props.deviceId, updatedThresholds)
            .then(() => {
                createNotification('Update Successful', 'Done', 'Success');
                this.props.updateThresholds([updatedThresholds]);
                this.setState({ showUpdateButton: true, loadStatusUpdateThreshold: '' });
            })
            .catch((error) => {
                createNotification(error.message, 'Error', 'Error');
                this.setState({ showUpdateButton: true });
            });

    };

    refreshActiveNotifications = () => {
        this.setState({
            showRefreshButtonActive: false,
            refreshActiveTable: <div className="forCenter">
                <CircularIndeterminate2 />
            </div>,
            activeResults: '',
        });
        this.activeNotifications = [];
        this.pageNumberActive = 1;
        this.requestActiveNotificationsWrapper(this.pageNumberActive);
    };

    refreshClosedNotifications = () => {
        this.setState({
            showRefressButtonClose: false,
            refreshCloseTable: <div className="forCenter">
                <CircularIndeterminate2 />
            </div>,
            closedResults: '',
        });
        this.closedNotifications = [];
        this.pageNumberClosed = 1;
        this.requestClosedNotificationsWrapper(this.pageNumberClosed);
    };

    dispatchActionToHideLoader = () => {
        if (!this.state.partialLoaderStateActiveNotificationsData
            && !this.state.partialLoaderStateClosedNotificationsData) {
            this.props.hideLoader();
        }
    };

    componentWillMount() {
        this.props.showLoader();
    }

    render() {

        this.dispatchActionToHideLoader();

        return (<div className="notifications-page">
            <div>
                <div className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h1 className="mb-0">Notifications</h1>
                    Device ID: {this.props.deviceId}
                </div>
            </div>
            <div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-8 ">
                        <div className="jr-card activeNotification-wrapper">
                            <div className="jr-card-header">
                                <h3 className="card-heading d-inline-block">
                                    Active Notifications</h3>{this.state.refreshActiveTable}
                                {
                                    this.state.showRefreshButtonActive
                                        ? (<button
                                            onClick={() => {
                                                this.refreshActiveNotifications();
                                            }}
                                            className="float-right btn-refresh"
                                        >
                                            <i className="fa fa-refresh" aria-hidden="true" />
                                        </button>)
                                        : ''
                                }
                            </div>
                            <div className="jr-card-body ">
                                <div className="table-responsive">
                                    {
                                        this.state.activeNotifications.length
                                            ? (<table className="table table-bordered mb-0">
                                                <thead className="background-color-blue">
                                                    <tr>
                                                        <th scope="col">Type</th>
                                                        <th scope="col">Date</th>
                                                        <th scope="col">Description</th>
                                                        <th scope="col">Measured Value</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody onLoad={this.handleProcessLoadedActiveTable.bind(this)}>
                                                    {this.state.activeNotificationsJSX}
                                                </tbody>
                                            </table>)
                                            :
                                            <h3>{this.state.activeResults}</h3>
                                    }
                                    <br />
                                </div>
                                {this.state.loadStatusActiveTable}
                                {this.state.showMoreActiveNotifications}
                            </div>
                        </div>
                        <div className="jr-card clearedNotification-wrapper">
                            <div className="jr-card-header">
                                <h3 className="card-heading d-inline-block">Notification
                                    History</h3>{this.state.refreshCloseTable}
                                {
                                    this.state.showRefressButtonClose
                                        ? (<button
                                            onClick={() => {
                                                this.refreshClosedNotifications();
                                            }}
                                            className="float-right btn-refresh"
                                        >
                                            <i className="fa fa-refresh" aria-hidden="true" />
                                        </button>)
                                        : ''
                                }
                            </div>
                            <div className="jr-card-body ">
                                <div className="table-responsive">
                                    {
                                        this.state.closedNotifications.length
                                            ? (<table className="table table-bordered mb-0">
                                                <thead className="background-color-blue">
                                                    <tr>
                                                        <th scope="col">Type</th>
                                                        <th scope="col">Date</th>
                                                        <th scope="col">Description</th>
                                                        <th scope="col">Measured Value</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody onLoad={this.handleProcessLoadedClosedTable.bind(this)}>
                                                    {this.state.closedNotificationsJSX}
                                                </tbody>
                                            </table>)
                                            : <h3>{this.state.closedResults}</h3>
                                    }
                                    <br />

                                </div>
                                {this.state.loadStatusCloseTable}
                                {this.state.showMoreClosedNotifications}

                            </div>
                        </div>

                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="jr-card descriptionNotification-wrapper">
                            <div className="jr-card-header">
                                <h3 className="card-heading d-inline-block">Rules & Thresholds</h3>
                            </div>
                            <div className="jr-card-body ">
                                <div className="table-responsive">
                                    <table className="table table-bordered mb-0">
                                        <thead className="background-color-blue">
                                            <tr>
                                                <th className="text-center" colSpan="2">
                                                    <span>
                                                        <strong>Notification
                            </strong>
                                                    </span>
                                                    <span className="ml-2">Description</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center vertical-align-middle">
                                                    <div>Assurance<br />
                                                        <img className="pt-2"
                                                            src="../../../../assets/images/water-droplet.png" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <strong>
                                                        <p>Water Flooding</p>
                                                    </strong>
                                                    <span>Trigger notification when the spatial depth in the pit reduces below
                          </span>
                                                    <input
                                                        className="mx-1"
                                                        value={this.state.thresholdSpatialValue}
                                                        onChange={(e) => {
                                                            this.spatialDepthThresholdChange(e);
                                                        }}
                                                    />
                                                    <span>cm,
                          </span>
                                                    <span className="ml-1">
                                                        within
                          </span>
                                                    <input
                                                        className="mx-1"
                                                        value={this.state.thresholdWaterTime}
                                                        onChange={(e) => {
                                                            this.waterTimeThresholdChange(e);
                                                        }}
                                                    />
                                                    <span>
                                                        minutes.</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-center vertical-align-middle">
                                                    <div>HSE<br />
                                                        <img className="pt-2" src="../../../../assets/images/fire.png" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <strong>
                                                        <p>Gas Leakage</p>
                                                    </strong>
                                                    <span>Trigger notification when the air quality in the pit reduces below
                          </span>
                                                    <input
                                                        className="mx-1"
                                                        value={this.state.thresholdGasValue}
                                                        onChange={(e) => {
                                                            this.gasLeakageThresholdChange(e);
                                                        }}
                                                    />
                                                    <span>
                                                        g/m<sup>3</sup>,
                          </span>

                                                    <span className="ml-1">
                                                        within
                          </span>
                                                    <input
                                                        className="mx-1"
                                                        value={this.state.thresholdGasTime}
                                                        onChange={(e) => {
                                                            this.gasTimeThresholdChange(e);
                                                        }}
                                                    />
                                                    <span>
                                                        minutes.</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-center vertical-align-middle">
                                                    <div>HSE<br />
                                                        <img className="pt-2" src="../../../../assets/images/power.png" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <strong>
                                                        <p>Power Leakage</p>
                                                    </strong>
                                                    <span>Trigger notification when the current measurement in the pit exceeds
                          </span>
                                                    <input
                                                        className="mx-1"
                                                        value={this.state.thresholdPowerValue}
                                                        onChange={(e) => {
                                                            this.powerLeakageThresholdChange(e);
                                                        }}
                                                    />
                                                    <span>
                                                        mA,
                          </span>

                                                    <span className="ml-1">
                                                        or the voltage measurement exceeds
                          </span>
                                                    <input
                                                        className="mx-1"
                                                        value={this.state.thresholdPowerVolt}
                                                        onChange={(e) => {
                                                            this.powerVoltThresholdChange(e);
                                                        }}
                                                    />
                                                    <span>
                                                        V</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-center vertical-align-middle">
                                                    <div>Security<br />
                                                        <img className="pt-2" src="../../../../assets/images/lock.png" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <strong>
                                                        <p>Intrusion Detected</p>
                                                    </strong>
                                                    <span>Trigger notification when the accelerometer Z-axis moves by more than
                          </span>
                                                    <input
                                                        className="mx-1"
                                                        value={this.state.thresholdIntrusionValue}
                                                        onChange={(e) => {
                                                            this.intrusionThresholdChange(e);
                                                        }}
                                                    />
                                                    <span>
                                                        degrees
                          </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div>
                                <input type="checkbox"
                                    checked={this.state.isSMSChecked}
                                    onChange={this.toggleSMSCheckbox} />
                                <span className="ml-2">Send SMS Notification when triggered</span>
                            </div>
                            <div><input type="checkbox" />
                                <span className="ml-2">Apply to All Devices</span>
                            </div>
                            {this.state.loadStatusUpdateThreshold}
                            {
                                this.state.showUpdateButton
                                    ? (
                                        <button onClick={this.onUpdateClick} className="mt-2 btn-showMore">Update Thresholds
                                        </button>)
                                    : ''
                            }
                            <NotificationContainer />
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}

const mapStateToProps = ({ symbioticReducer, profileInfo }) => {
    return {
        deviceId: symbioticReducer.deviceId,
        thresholds: symbioticReducer.thresholds,
        isSMSNotificationChecked: profileInfo.smsNotification,
        userAttributes: profileInfo.userAttributes,
        notificationPageTimestampOfElementToHighlight: symbioticReducer.notificationPageTimestampOfElementToHighlight
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        smsNotification: (isSMSChecked) => {
            dispatch({ type: 'UPDATE_SMS_NOTIFICATION', isSMSNotificationChecked: isSMSChecked });
        },
        showLoader: () => {
            dispatch({ type: 'SHOW_OVERALL_APP_LOADER' });
        },
        hideLoader: () => {
            dispatch({
                type: 'HIDE_OVERALL_APP_LOADER'
            });
        },
        manualClearClicked: (id, ts) => {
            dispatch({ type: 'MANUAL_CLEAR_CLICKED', notificationDeviceId: id, notificationTimestamp: ts });
        },
        removeActiveNotificationTimestampFromProps: (deviceId) => {
            dispatch({ type: 'UPDATE_DEVICE_ID_AND_TIMESTAMP', deviceId: deviceId, notificationPageTimestampOfElementToHighlight: null });
        },
        updateThresholds: (data) => {
            if (data && data[0]) {
                dispatch({ type: 'UPDATE_THRESHOLDS', data });
            }
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./app/routes/notifications/index.js